<template>
  <div>
    <v-btn :id="elementId" :aria-label="elementId"
      @click="filterClicked"
      small :outline="!enabled" color="primary">
      <v-icon v-if="icon" class="ml-1 icon-left">{{icon}}</v-icon>
      <span :class="{'nudge-right': icon, 'primary-text': enabled, 'dark-adjustment': $vuetify.dark && !enabled}">{{$t(text)}}</span>
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'filter-button',
    props: {
      filterName: {
        type: String,
        required: true
      },
      filterType: {
        type: String,
        required: true
      },
      enabled: {
        type: Boolean,
        required: true
      },
      text: {
        type: String,
        required: true
      },
      icon: {
        type: String,
        required: false
      },
      elementId: {
        type: String
      }
    },
    mixins: [],
    data () {
      return {}
    },
    methods: {
      filterClicked () {
        this.$emit('filter:button-change', {filterName: this.filterName, filterType: this.filterType})
      }
    },
    computed: {},
    watch: {}
  }
</script>

<style scoped>
  .dark-adjustment {
    color: white;
  }

  .btn {
    min-width:160px;
    max-width: 100%;
    justify-content: left;
  }

  .icon-left {
    position: absolute;
    top: 0;
    left: 0;
  }

  .nudge-right {
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertFilterButton.vue